import { render, staticRenderFns } from "./ShrinkableFilter.vue?vue&type=template&id=55c61d88&scoped=true&"
import script from "./ShrinkableFilter.vue?vue&type=script&lang=js&"
export * from "./ShrinkableFilter.vue?vue&type=script&lang=js&"
import style0 from "./ShrinkableFilter.vue?vue&type=style&index=0&id=55c61d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c61d88",
  null
  
)

export default component.exports